import { useParams } from 'react-router-dom';
import './upload-dealer-documents.css';

export default function UploadDealerDocumentsContainer() {
  const { dealerDocumentId } = useParams();

  return (
    <div className="UploadDealerDocuments text-center">
      <h3>Upload Dealer Documents</h3>
      <p>Document ID: {dealerDocumentId}</p>
    </div>
  );
}
